export const seasonalPerks = [
  { check: true, label: 'Seasonal Box: 6 full-size products' },
  { check: true, label: 'Customize your entire box' },
  { check: true, label: 'Unlimited Swap for Credit' },
  { check: false, label: 'Early access to Customize' },
  { check: false, label: 'Early access to Add-Ons/Edit Sales' },
  { check: false, label: 'Earlier shipping' },
  { check: true, label: 'Cancel anytime' },
];
export const annualPerks = [
  { check: true, label: 'Seasonal Box: 6 full-size products' },
  { check: true, label: 'Customize your entire box' },
  { check: true, label: 'Unlimited Swap for Credit' },
  { check: true, label: 'Early access to Customize' },
  { check: true, label: 'Early access to Add-Ons/Edit Sales' },
  { check: true, label: 'Earlier shipping' },
  { check: true, label: 'Cancel anytime' },
];
export const SEASONAL = 'SEASONAL';
